<template>
  <a
    :class="[
      {
        link: theme !== 'custom',
        'link-primary': theme === 'primary',
        'link-accent': theme === 'accent',
        'link-hover': hover,
      },
    ]"
    :href="href"
    :target="target"
  >
    <slot />
  </a>
</template>
<script lang="ts" setup>
  import type { MLinkProps } from '.';

  withDefaults(defineProps<MLinkProps>(), { theme: 'custom', hover: false, href: '#', target: '_self' });
</script>
